import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { air, dur } from "./api";
import { Filters } from "./Filters";

const CARDS = [["calls_received", "Calls received"], ["answered_by_ai", "Answered by AI"], ["human_follow_up", "Need human follow-up"], ["missed", "Missed calls"],
  ["booking_enquiries", "Booking enquiries"], ["catering_enquiries", "Catering enquiries"], ["corporate_leads", "Corporate leads"], ["complaints", "Complaints"],
  ["avg_duration_sec", "Avg call duration"], ["converted", "Converted to bookings"]];

export function DashboardPanel({ token, centres }) {
  const [f, setF] = useState({ include_tests: true });
  const [d, setD] = useState(null);
  const load = useCallback(() => air("dashboard", token, f).then(setD).catch((e) => toast.error(e.message)), [token, f]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-3" data-testid="air-dashboard">
      <Filters f={f} setF={setF} centres={centres} testPrefix="air-dash" />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
        {CARDS.map(([k, l]) => (
          <div key={k} className="rounded border p-3" data-testid={`air-stat-${k}`}>
            <p className="text-[11px] text-muted-foreground">{l}</p>
            <p className="text-2xl font-semibold">{d ? (k === "avg_duration_sec" ? dur(d[k]) : d[k]) : "…"}</p>
          </div>))}
      </div>
    </div>
  );
}
